<template>
  <div>
    <b-row class="fixed-bottom d-print-none">
      <b-col>
        <b-button class="open-card-btn fixed-bottom custom-margin-bottom  rounded-circle m-1" v-b-toggle.shopping-cart
                  @click="reloadBasket">
          <img :src="setShoppingCartIcon()" alt="">
        </b-button>
      </b-col>
    </b-row>
    <b-sidebar id="shopping-cart" title="" :width="setSidebarSize" text-variant="white" shadow
               backdrop>
      <h3 class="px-3 h1 text-center">سبد خرید</h3>
      <b-container fluid class="p-0">

        <b-row class="p-0 m-0 w-100" v-if="IsAuthenticated">
          <b-col cols="12" v-for="food in foods" :key="food.id" class="pb-0 my-1">
            <m-c17 :food="food.product" :basket="basket"/>
          </b-col>
        </b-row>
        <b-row class="p-0 m-0 w-100" v-else>
          <b-col cols="12" v-for="food in productList" :key="food.id" class="p-2 pb-0">
            <m-c17 :food="food" :basket="basket"/>
          </b-col>
        </b-row>

        <b-col v-if="this.basket.items !== undefined && this.basket.items.length > 0 && IsAuthenticated" cols="12"
               class="text-center my-2">
          <router-link :to="{ name: 'ShoppingCart' }" class="text-center">
            <b-button class="pay-button  m-2 p-3" pill>
              پرداخت آنلاین
            </b-button>
          </router-link>
        </b-col>
        <b-col v-if="!IsAuthenticated" cols="12"
               class="text-center my-2">

          <m-un-auth-summary-1 :products="productList"/>

          <router-link :to="{ name: 'Login' }" class="text-center">
            <b-button class="pay-button m-2 p-3" pill>
              وارد حساب کاربری خود شوید
            </b-button>
          </router-link>
        </b-col>

      </b-container>
    </b-sidebar>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";

export default {
  name: "Sc2",
  props: {
    haveItem: {
      default: require('../../assets/tray-meal-svgrepo-com.svg')
    },
    empty: {
      default: require('../../assets/tray-dish-svgrepo-com (3).svg')
    }
  },
  data() {
    return {
      shoppingCartCount: 0,
    }
  },
  computed: {
    ...mapGetters({
      foods: "ShoppingCart/getUserOrderUnpaidItems",
      basket: "ShoppingCart/getSidebarBasketData",
      IsAuthenticated: "User/isAuthenticated",
      productList: "ShoppingCart/getProductList"
    }),
    setSidebarSize() {
      if (window.screen.width > 500) {
        return '500px';
      }
      return '320px';
    }
  },
  methods: {
    setShoppingCartIcon() {
      if ((this.basket.items !== undefined && this.basket.items.length > 0) || this.shoppingCartCount > 0) {
        return this.haveItem;
      }
      return this.empty;
    },
    async getUnAuthBasketItems() {
      if (localStorage.getItem('products') !== null) {

        let productsJson = JSON.parse(localStorage.getItem('products'))
        let form = new FormData();
        let counter = 0;

        Object.keys(productsJson).forEach(function (key) {
          form.append(`product[${counter}][id]`, productsJson[key]['id'])
          if (productsJson[key]['sub_product_id'] > 0) {
            form.append(`product[${counter}][sub_product]`, productsJson[key]['sub_product_id'])
          }
          counter += 1;
        })

        let user_id = this.$store.getters['User/getUserId']
        store.dispatch("ShoppingCart/addItemWithoutState", {user_id, form}).then(res => {
          const shoppingCart = res.data.data;
          const order_id = shoppingCart.id;
          const items = shoppingCart.items;


          // find local storage item in shopping cart items
          items.forEach(item => {
            Object.keys(productsJson).forEach(function (key) {
              let product = productsJson[key];
              if (product['sub_product_id'] == item.sub_product && product['id'] == item.product.id) {

                let form = {
                  order_id: order_id,
                  order_product_id: item.id,
                  quantity: product['quantity'],
                  user_id: user_id,
                }

                store.dispatch("ShoppingCart/changeQuantityWithoutState", form)

              }
            })
          })


        })

        this.$store.dispatch('ShoppingCart/userOrderUnpaid')
        localStorage.removeItem('products')

      }
    },
    async reloadBasket() {
      let productsLink = [];
      let productsJson = JSON.parse(localStorage.getItem('products'))
      if (productsJson !== null) {
        Object.keys(productsJson).forEach(function (key) {
          productsLink.push(productsJson[key]['product'])
        })
        await this.$store.dispatch("ShoppingCart/getProductList", productsLink)
      }
    },
    countItemsOnUnAuthenticatedShoppingCart() {
      const localProducts = localStorage.products;
      this.shoppingCartCount = localProducts != undefined ? Object.keys(JSON.parse(localStorage.products)).length : 0;
      this.$forceUpdate();
    },
  },
  async mounted() {
    if (this.$store.getters['User/isAuthenticated']) {
      await this.$store.dispatch("ShoppingCart/userOrderUnpaid")
      await this.getUnAuthBasketItems(this.$store.getters["ShoppingCart/getSidebarBasketData"])
    } else {
      let productsLink = [];
      let productsJson = JSON.parse(localStorage.getItem('products'))
      if (productsJson !== null) {
        Object.keys(productsJson).forEach(function (key) {
          productsLink.push(productsJson[key]['product'])
        })
        await this.$store.dispatch("ShoppingCart/getProductList", productsLink)
      }


      this.countItemsOnUnAuthenticatedShoppingCart();
      window.addEventListener('click', this.countItemsOnUnAuthenticatedShoppingCart);
      window.addEventListener('DOMContentLoaded', this.countItemsOnUnAuthenticatedShoppingCart);


    }


  }
}
</script>

<style>
#shopping-cart {
  background-color: var(--primary) !important;
}

.open-card-btn {
  background-color: var(--primary) !important;
}

.fixed-bottom {
  width: 70px;
  height: 70px;

}

.custom-margin-bottom {
  bottom: 70px !important;
}


.pay-button {
  bottom: 30px;
  border: none !important;
}

@media screen and (max-width: 480px) {
  .open-card-btn {
    bottom: 90px;
  }
}
</style>